import React, { useState } from 'react';
import { auth } from './api';
import { useAuth } from './AuthContext';
import './Portal.css';

export default function ChangePassword() {
  const { refresh } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus(null);

    if (next !== confirm) {
      setStatus({ type: 'error', message: 'The two new passwords do not match.' });
      return;
    }

    setBusy(true);
    try {
      await auth.changePassword(current, next);
      setStatus({ type: 'success', message: 'Password updated. Use the new one next time you sign in.' });
      setCurrent('');
      setNext('');
      setConfirm('');
      // Clears the "temporary password" banner in the shell.
      refresh();
    } catch (err) {
      setStatus({ type: 'error', message: err.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pt-card" style={{ maxWidth: 520 }}>
      <form className="pt-form" onSubmit={handleSubmit}>
        <div className="pt-field">
          <label className="pt-label" htmlFor="pt-current">
            Current password
          </label>
          <input
            id="pt-current"
            className="pt-input"
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
          />
        </div>

        <div className="pt-field">
          <label className="pt-label" htmlFor="pt-new">
            New password
          </label>
          <input
            id="pt-new"
            className="pt-input"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
          />
          <span className="pt-hint">At least 10 characters, including a letter and a number.</span>
        </div>

        <div className="pt-field">
          <label className="pt-label" htmlFor="pt-confirm">
            Confirm new password
          </label>
          <input
            id="pt-confirm"
            className="pt-input"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>

        {status && (
          <div className={'pt-notice pt-notice-' + (status.type === 'error' ? 'error' : 'success')}>
            {status.message}
          </div>
        )}

        <div className="pt-actions">
          <button className="pt-btn pt-btn-primary" type="submit" disabled={busy}>
            {busy ? 'Saving…' : 'Update password'}
          </button>
        </div>
      </form>
    </div>
  );
}
